import '../../styles/sections/collection-main.scss';
import '../../styles/sections/product-listing.scss';
import '../../styles/components/load-more-pagination.scss';
import '../../styles/components/promo-tile.scss';
import React from "react";
import { createRoot } from 'react-dom/client';
import { ProductListing } from "../react_components/ProductListing";

const rootElements = Array.from(document.querySelectorAll('[data-product-listing]'));

// creates the roots to render the react components
if (rootElements.length > 0) {
  rootElements.forEach(rootEl => {
    const root = createRoot(rootEl);
    if (root) {
      root.render(
        <ProductListing />
      );
      rootEl._reactRootContainer = root;
    }
    window.resizeTo(window.innerWidth, window.innerHeight);
  });
}
